import plugin from '../../lib/vanilla-plugin';
import WindcavePresubmit from '@core/modules/windcave-presubmit/windcave-presubmit';
import RecaptchaPresubmit from '@core/modules/recaptcha-presubmit/recaptcha-presubmit';
import debug from 'debug';
const log = debug('presubmit-check');

class PresubmitCheck {
	constructor(element, options = {}) {
		this.element = element;
		this.options = options;
		this.init();
	}

	init() {
		log(this.element, this.options);

		if (this.element.dataset.recaptchaPresubmit !== undefined) {
			this.recaptchaPresubmit = plugin(
				'recaptchaPresubmit',
				RecaptchaPresubmit,
				[this.element]
			)({ isWatching: false });
		}

		if (this.element.dataset.windcavePresubmit !== undefined) {
			this.windcavePresubmit = plugin(
				'windcavePresubmit',
				WindcavePresubmit,
				[this.element]
			)({ isWatching: false });
		}

		this.element.addEventListener('submit', this.onSubmit.bind(this));
	}

	onSubmit(event) {
		event.preventDefault();

		const validations = [];

		if (this.recaptchaPresubmit) {
		  validations.push(this.recaptchaPresubmit[0].requestValidation());
		}

		if (this.windcavePresubmit) {
		  validations.push(this.windcavePresubmit[0].requestValidation());
		}

		Promise.all(validations)
			.then(() => {
				this.element.submit();
				log('Form submitted');
			})
			.catch((error) => {
				log('Error', error);

				this.element.dispatchEvent(
					new CustomEvent('enableSubmit', {
						bubbles: false,
						cancelable: true,
					})
				);
			});
	}

	destroy() {
		this.element.form.removeEventListener('submit', this.onSubmit);
	}
}

PresubmitCheck.DEFAULTS = {};

export default PresubmitCheck;


// WEBPACK FOOTER //
// ./client/src/core/modules/presubmit-check/presubmit-check.js